"use client"
import React from "react";
import ReactMarkdown from "react-markdown";
import CTA from "./CTA"

function Title(props) {
    const {title, maxTitleLength} = props;
    if (maxTitleLength > 15) {
        return <h4 className="text-center text-md-start">
            {title}
        </h4>
    }
    else {
        return (<h3 className="text-center text-md-start">
            {title}
        </h3>)
    }
}

export default function CardValueProp(props) {
    const {title, description, cta, image, isCardEnabled, reverse = false, id, config, maxTitleLength, siteConfig} = props

    function getImageStyle() {
        if (config?.imagePerRow) {
            return ''
        } else {
            return `col-md-6 ${reverse ? 'order-md-1' : 'order-md-2'}`
        }
    }

    function getContentStyle() {
        if (config?.imagePerRow) {
            return ''
        } else {
            return `col-md-6 ${reverse ? 'order-md-2' : 'order-md-1'}`
        }
    }


    const imageContainerStyle = getImageStyle();
    const contentStyle = getContentStyle();

    return (<section className="home-card-section p-3" key={`value-prop-${id}`}>
        <div className="container p-0 value-prop" key={`container-${id}`}>
            <div
                className={`col-xl-10 offset-xl-1 text-center ${isCardEnabled && "card rounded-3 shadow"} justify-content-start align-items-start`}>
                <div className={`block-contents ${isCardEnabled && "p5"}`}>
                    <div key={`row-${id}`} className="row">
                        {cta && cta.urgencyText &&
                            <div className="cta-annotation">
                                {cta?.urgencyText}
                            </div>
                        }
                        <div
                            key={`row-style-${id}`}
                            className={`mb-5 mb-md-0 col-12 col-xs-12 ${imageContainerStyle}`}>
                            <img className={`${isCardEnabled && "p-5"}`} src={image?.url} alt={image?.alt}/>
                        </div>
                        <div className={`${isCardEnabled && "p-5"} section-title col d-flex flex-column align-items-center justify-content-center col-12 col-xs-12 ${contentStyle}`}>
                            <div className="mb-0">
                                <Title title={title} maxTitleLength={maxTitleLength} />
                            </div>

                            <div className="section-subtext text-center text-md-start text-body-emphasis">
                                <ReactMarkdown>{description}</ReactMarkdown>
                            </div>
                            <CTA cta={cta} reverse={reverse} siteConfig={siteConfig}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>);
}
